import { render, staticRenderFns } from "./DrugList.vue?vue&type=template&id=028c9d96&scoped=true&"
import script from "./DrugList.vue?vue&type=script&lang=js&"
export * from "./DrugList.vue?vue&type=script&lang=js&"
import style0 from "./DrugList.vue?vue&type=style&index=0&id=028c9d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c9d96",
  null
  
)

export default component.exports